import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface EmptyProps {
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

// Editorial empty state — no template-y centered icon, no gradient blob.
// Left-aligned, generous whitespace, a single primary action.
export function Empty({ title, description, action, className }: EmptyProps) {
  return (
    <div
      role="status"
      className={cn('surface flex flex-col items-start gap-3 p-10', 'max-w-prose', className)}
    >
      <h3 className="font-[var(--font-display)] tracking-[var(--tracking-tight)] text-[var(--text-2xl)]">
        {title}
      </h3>
      {description && (
        <p className="leading-[var(--leading-relaxed)] text-[var(--color-ink-muted)]">
          {description}
        </p>
      )}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
